import { Grid } from '@mui/material';
import { FC } from 'react';

import { Projekt } from '../../api/projekt.types';

import { ProjektMitarbeiterCard } from './projektMitarbeiterCard/ProjektMitarbeiterCard';
import { ProjektStammdatenCard } from './ProjektStammdatenCard';

export const ProjektDetails: FC<{ projekt: Projekt }> = ({ projekt }) => (
  <Grid container spacing={2} sx={{ width: '50%' }}>
    <Grid size={12}>
      <ProjektStammdatenCard projekt={projekt} />
    </Grid>
    <Grid size={12}>
      <ProjektMitarbeiterCard projekt={projekt} />
    </Grid>
  </Grid>
);
